module.exports = __webpack_public_path__ + "static/book-appointment-28a82a23bbb8b7a32b24f5a4bcf9c5f7.png";